import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SearchHistoryService } from './search-history.service';

export const restoreSearchHistory: CanActivateFn = route =>
  inject(SearchHistoryService).enter(route.data['searchDomain'], route);
